export default __webpack_public_path__ + "profile_sm@2x.123db305.png";